import { isDocumentVisible } from '../../utils';

function useListeners() {
  var listeners = [];
  return {
    get: function get() {
      return listeners;
    },
    add: function add(listener) {
      listeners.push(listener);
    },
    remove: function remove(listener) {
      var index = listeners.indexOf(listener);

      if (index > -1) {
        listeners.splice(index, 1);
      }
    }
  };
}

var focusListeners = useListeners();
var blurListeners = useListeners(); // 为方便统计有多少个已经注册的组件，这里加一个计数

var count = 0;

function flush(listeners) {
  listeners.forEach(function (listener) {
    return listener();
  });
}

function flushFocus() {
  flush(focusListeners.get());
}

function flushBlur() {
  flush(blurListeners.get());
}

function visibilityChangeListener() {
  if (isDocumentVisible()) {
    flushFocus();
  } else {
    flushBlur();
  }
}

var TIMEOUT = 20;
var STATUS_NONE = 0;
var STATUS_INPUT_BLUR = 1;
var STATUS_WIN_BLUR = 2;
var STATUS_WIN_FOCUS = 3;

function createWindowFocusMonitor() {
  var hasSetup = false;
  var refocusState = STATUS_NONE;
  var resetTimer = null;

  function clearResetTimer() {
    if (resetTimer) {
      window.clearTimeout(resetTimer);
      resetTimer = null;
    }
  }

  function setState(nextState) {
    if (!hasSetup) return;

    if (nextState === STATUS_NONE) {
      clearResetTimer();
      refocusState = STATUS_NONE;
      return;
    }

    if (refocusState === nextState - 1) {
      clearResetTimer();
      refocusState = nextState;

      if ([STATUS_WIN_FOCUS, STATUS_INPUT_BLUR].indexOf(nextState) > -1) {
        resetTimer = window.setTimeout(function () {
          setState(STATUS_NONE);
        }, TIMEOUT);
      }
    }
  }

  function windowFocusListener() {
    setState(STATUS_WIN_FOCUS);
  }

  function windowBlurListener() {
    setState(STATUS_WIN_BLUR);
  }

  return {
    setup: function setup() {
      if (!hasSetup) {
        hasSetup = true;
        focusListeners.add(windowFocusListener);
        blurListeners.add(windowBlurListener);

        if (count++ === 0) {
          window.addEventListener('visibilitychange', visibilityChangeListener);
          window.addEventListener('focus', flushFocus);
          window.addEventListener('blur', flushBlur);
        }
      }
    },
    teardown: function teardown() {
      if (hasSetup) {
        focusListeners.remove(windowFocusListener);
        blurListeners.remove(windowBlurListener);

        if (--count === 0) {
          window.removeEventListener('visibilitychange', visibilityChangeListener);
          window.removeEventListener('focus', flushFocus);
          window.removeEventListener('blur', flushBlur);
        }

        setState(STATUS_NONE);
        hasSetup = false;
      }
    },

    /**
     * 整个判定过程由当前注册的input组件发生blur事件开始:
     *   1. input触发了blur事件，状态前进一步，超时归零；
     *   2. window失焦，状态前进一步；
     *   3. window重新聚焦，状态前进一步，超时归零。
     * 当状态走到三时，表明当前满足refocus条件，需要跳过修改光标位置的操作
     */
    startUp: function startUp() {
      setState(STATUS_INPUT_BLUR);
    },
    isRefocused: function isRefocused() {
      return refocusState === STATUS_WIN_FOCUS;
    },
    // for test
    getState: function getState() {
      return {
        hasSetup: hasSetup,
        refocusState: refocusState,
        resetTimer: resetTimer
      };
    }
  };
}

;
export default createWindowFocusMonitor; // export for test

export function getMonitorState() {
  return {
    focusListeners: focusListeners,
    blurListeners: blurListeners
  };
}